export function timeOfDayFilterParser(_root, softOrder) {
  const tacticValue = softOrder.value.tacticValue;
  const startHour = tacticValue.startHour;
  const startMinute = tacticValue.startMinute;
  const endHour = tacticValue.endHour;
  const endMinute = tacticValue.endMinute;
  let status;
  const now = new Date();
  const marketTime = now.toLocaleString('en-GB', {
    timeZone: 'America/New_York',
  });
  const time = marketTime.split(', ')[1];
  const [nowHour, nowMinute] = time.split(':');
  const nowInMinutes = Number(nowHour) * 60 + Number(nowMinute);
  const startMinutes = Number(startHour) * 60 + Number(startMinute);
  const endMinutes = Number(endHour) * 60 + Number(endMinute);
  if (nowInMinutes >= startMinutes && nowInMinutes <= endMinutes) status = true;
  else status = false;

  return {
    status,
    details: {
      startHour,
      startMinute,
      endHour,
      endMinute,
    },
  };

}
